// extracted by mini-css-extract-plugin
export default {"stack":"cardStack_stack__HtENg","card":"cardStack_card__2Foq+","top":"cardStack_top__s9mJD","dragging":"cardStack_dragging__9NwkW"};